var _Path, _Path2, _Path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgHandGasture(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M19.396 14.392V7.79c0-1.042.845-1.887 1.887-1.887s1.887.843 1.887 1.885v13.68c0 2.831-3.302 5.19-7.076 5.19-3.019 0-4.402-.63-4.717-.944l-8.962-8.962a2.001 2.001 0 012.83-2.83l2.373 2.373c.169.168.457.049.457-.19v-4.07"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M19.397 9.204V5.43a1.887 1.887 0 00-3.774 0v8.963"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M15.623 7.317V3.544a1.887 1.887 0 00-3.774 0v5.188M11.849 14.393V5.43a1.887 1.887 0 10-3.774 0v8.963"
  })));
}

export default SvgHandGasture;